/**
 * `AW48` — el borde de la configuración del chatbot, disponible para el árbol.
 *
 * Mismo patrón que `contexto-borde-exportacion.tsx` y por la misma razón de
 * fondo: **inyectado, el borde se puede reemplazar por un doble**. La pantalla se
 * puede ejercer contra un doble en memoria, sin base, sin red y sin
 * `apps/admin-web` — y eso sólo es posible si el borde entra por afuera. Un
 * `crearBordeConfiguracionHttp()` llamado adentro del componente haría que la
 * única forma de probarlo fuera interceptar `fetch`, que es probar el transporte
 * en vez de la pantalla.
 *
 * ⭐ Y acá pesa el doble: el agente que atiende estas seis rutas del otro lado
 * trabaja **en paralelo** contra el mismo contrato. Con el borde inyectado, esta
 * pantalla se verifica entera antes de que exista una sola tabla.
 */

import { createContext, useContext } from "react"
import type { BordeConfiguracion } from "./configuracion-del-chatbot/borde-configuracion.ts"

/**
 * Sin valor por defecto, igual que los otros contextos de borde.
 *
 * Un doble por defecto acá haría que un componente montado fuera del proveedor
 * anduviera igual, escribiendo en el aire. Falla en el primer render.
 */
const ContextoBordeConfiguracion = createContext<BordeConfiguracion | null>(null)

export const ProveedorBordeConfiguracion = ContextoBordeConfiguracion.Provider

export function useBordeConfiguracion(): BordeConfiguracion {
  const borde = useContext(ContextoBordeConfiguracion)
  if (borde === null) {
    throw new Error(
      "useBordeConfiguracion() se llamó fuera de <ProveedorBordeConfiguracion>. El borde se arma en App.tsx con la configuración ya leída.",
    )
  }
  return borde
}
